import axios from "axios";
import { apiBaseUrl } from "../../../helpers/UrlHelper";
import { loginToken } from "../../../helpers/LocalStorageHelper";
import { handleError, handleSuccess } from "../../../helpers/ErrorHelper";
import store from "../../../Store";
import { scrollToError } from "../../../helpers/ScrollHelper";
import getSiteStatus from "../sites/site_status_get";
import {
  cancelServerMigrationDispatch,
  serverMigrationServerValidationErrors,
} from "../../../pages/site/server-migration-block/form/ServerMigration-Action";

function _success(success) {
  return { type: "CREATE_MIGRATION_SUCCESS", success };
}

function _error(error) {
  return { type: "CREATE_MIGRATION_ERROR", error };
}

function _processing(processing) {
  return { type: "CREATE_MIGRATION_PROCESSING", processing };
}

function createServerMigration(site_id, orz_id) {
  return (dispatch, getState) => {
    let { serverMigrationForm } = getState();

    dispatch(_success(null));
    dispatch(_error(null));
    dispatch(_processing(true));

    axios({
      url: apiBaseUrl(
        `admin/organizations/${orz_id}/sites/${site_id}/live-migrate`
      ),
      method: "post",
      dataType: "json",
      data: serverMigrationForm.data.payload,
      headers: {
        Authorization: "Bearer " + loginToken(),
      },
    })
      .then(function (res) {
        dispatch(_success(res));
        dispatch(_processing(false));
        handleSuccess("Server migration request is successfully sent.");
        store.dispatch(getSiteStatus(site_id, orz_id));
        store.dispatch(cancelServerMigrationDispatch());
      })
      .catch(function (error) {
        dispatch(_error(error.response.data.data));
        dispatch(_processing(false));
        handleError(error);

        store.dispatch(cancelServerMigrationDispatch());
        if (error.response && error.response.status === 422) {
          store.dispatch(
            serverMigrationServerValidationErrors(error.response.data.errors)
          );
          scrollToError();
        }
      });
  };
}
//scp -r -P 11042 build keplerhq@188.126.70.139:/app/

//ssh -p 11042 keplerhq@188.126.70.139

export default createServerMigration;
